
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import './aside.css'
import profile from '../assets/profile.jpg'

function ProjectManagerAside() {


    const [salesData, setSalesData] = useState({
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        datasets: [
            {
                label: 'Sales Performance',
                data: [120, 150, 180, 200],
                borderColor: '#4CAF50',
                backgroundColor: 'rgba(76, 175, 80, 0.2)',
                fill: true,
                tension: 0.4,
            },
        ],
    });


    const [isLoading, setIsLoading] = useState(true);
    const [empId, setEmpId] = useState('');
    const [empName, setEmpName] = useState('');
    const [designation, setDesignation] = useState('');
     const [isSidebarOpen, setIsSidebarOpen] = useState(
        () => localStorage.getItem('mobileSidebarOpen') === 'true'
    );
    const navigate = useNavigate();

    useEffect(() => {
        // Load employee details from localStorage
        const storedEmpId = localStorage.getItem('empId');
        const storedEmpName = localStorage.getItem('empName');
        const storedDesignation = localStorage.getItem('designation');

        if (!storedEmpId || !storedEmpName || !storedDesignation) {
            alert('Session expired. Please log in again.');
            navigate('/');
        } else {
            setEmpId(storedEmpId);
            setEmpName(storedEmpName);
            setDesignation(storedDesignation);
            setIsLoading(false);
        }
    }, [navigate]);

    // Logout function
    const handleLogout = () => {
        localStorage.removeItem('empId');
        localStorage.removeItem('empName');
        localStorage.removeItem('designation');
        navigate('/');
    };


    const handleSidebarToggle = () => {
        setIsSidebarOpen((prev) => {
            const next = !prev;
            localStorage.setItem('mobileSidebarOpen', String(next));
            return next;
        });
    };


    return (
       <div className={`sideBar ${isSidebarOpen ? 'is-open' : ''}`}>
            <button
                type="button"
                className="mobile-sidebar-toggle"
                aria-label="Toggle sidebar"
                aria-expanded={isSidebarOpen}
                onClick={handleSidebarToggle}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className="imageBlock">
                <img src={profile} alt="" />

            </div>
            <div className="employeeDetails">
                <h4><span className="empvalues">{empId} </span></h4>
                <h4><span className="empvalues">{empName}</span></h4>
                <h4><span className="empvalues">{designation}</span></h4>
            </div>

            <Link to="/ProjectManagerDashboard/Leaveportal" className="links">Leave Portal</Link>
             {/* <Link to="/Taskupdate" className="links">Team Task Update</Link> */}
            <Link to="/Taskassignmentretrival" className="links">Task Assignment</Link>
            <Link to="/Employeeproductivityformanager" className="links">Employee Productivity</Link>

            <div className="logout-container">
                <button onClick={handleLogout} className="logout-button">
                    Logout
                </button>
            </div>
        </div>
    )


}

export default ProjectManagerAside;